// const BASE_URL = 'http://192.168.1.3:8083';
// const BASE_URL = 'http://192.168.29.110:8083';
// const BASE_URL = 'http://192.168.2.52:8083';
// const BASE_URL = 'http://192.168.1.46:8083';
const BASE_URL = 'https://api.te.parkoye.com';

export { BASE_URL };
